module.exports = __webpack_public_path__ + "static/img/voice4_right.56676c89.png";